<!--
  Screenshot Capture Overlay
  ===========================
  Renders a dimmed mask with a cutout for the in-progress selection rectangle.
  Only mounts when [active]=true (handled by the outer *ngIf in the host).
-->
<div
  *ngIf="active"
  #overlayRoot
  class="capture-root"
  @fadeIn
  role="application"
  aria-label="Screenshot capture overlay. Click and drag to select a region. Press Escape to cancel."
  (mousedown)="onMouseDown($event)"
  (mousemove)="onMouseMove($event)"
  (mouseup)="onMouseUp($event)"
  (mouseleave)="onMouseLeave()"
>
  <!-- SVG mask: dims everything except the selection rect -->
  <svg class="capture-mask" aria-hidden="true">
    <defs>
      <mask id="ss-capture-mask">
        <rect width="100%" height="100%" fill="white" />
        <rect
          *ngIf="selectionRect"
          [attr.x]="selectionRect.x"
          [attr.y]="selectionRect.y"
          [attr.width]="selectionRect.width"
          [attr.height]="selectionRect.height"
          fill="black"
        />
      </mask>
    </defs>
    <rect width="100%" height="100%" mask="url(#ss-capture-mask)" class="capture-scrim-rect" />
  </svg>

  <!-- Selection box with orange border, corner handles, dimensions badge -->
  <div
    *ngIf="selectionRect"
    class="capture-selection"
    [style.left.px]="selectionRect.x"
    [style.top.px]="selectionRect.y"
    [style.width.px]="selectionRect.width"
    [style.height.px]="selectionRect.height"
  >
    <span class="capture-selection-handle handle-tl" aria-hidden="true"></span>
    <span class="capture-selection-handle handle-tr" aria-hidden="true"></span>
    <span class="capture-selection-handle handle-bl" aria-hidden="true"></span>
    <span class="capture-selection-handle handle-br" aria-hidden="true"></span>
    <span class="capture-selection-badge">{{ selectionLabel }}</span>
  </div>

  <!-- Top instruction bar -->
  <div class="capture-instruction" role="status" aria-live="polite">
    <mat-icon class="capture-instruction-icon">photo_camera</mat-icon>
    <span class="capture-instruction-text">
      {{ isDragging ? 'Release to capture' : 'Click and drag to capture an area' }}
    </span>
    <kbd class="capture-instruction-kbd">ESC</kbd>
    <button
      type="button"
      class="capture-instruction-close"
      matTooltip="Cancel capture"
      aria-label="Cancel capture"
      (click)="cancel.emit()"
      (mousedown)="$event.stopPropagation()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
